import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromAuthReducers from './auth/reducers';
import * as fromParticipantsReducers from './participants/reducers';
import * as fromConversationReducers from './conversation/reducers';
import * as fromMessagesReducers from './message/reducers';

export interface AppState {
  auth: fromAuthReducers.AuthState;
  participant: fromParticipantsReducers.participantsState;
  conversation: fromConversationReducers.conversationState;
  message: fromMessagesReducers.MessageState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: fromAuthReducers.reducer,
  participant: fromParticipantsReducers.reducer,
  conversation: fromConversationReducers.reducer,
  message: fromMessagesReducers.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = [debugMetaReducer];

//#region enableDebugMetaReducer

export let debugMetaReducerEnabled = false;

export const enableDebugMetaReducer = () => (debugMetaReducerEnabled = true);

export function debugMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  if (!debugMetaReducerEnabled) {
    return reducer;
  }

  return (state, action) => {
    const result = reducer(state, action);

    console.groupCollapsed(action.type);
    console.log('%cAction:', 'color: lightblue');
    console.dir(action);
    console.log('%cState:', 'color: orangered');
    console.dir(state);
    console.log('%cResult:', 'color: greenyellow');
    console.dir(result);
    console.groupEnd();

    return result;
  };
}

//#endregion
